module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "layout-has-top layout-main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('section', {
    staticClass: "layout-bottom bor-top",
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_c('menus-horizon', {
    attrs: {
      "size": "sm",
      "current": this.$route.path,
      "surface": [{
        icon: 'like',
        currentIcon: 'likefill',
        alias: '/home',
        title: '首 页'
      }, {
        icon: 'time',
        currentIcon: 'timefill',
        alias: '/mobile/demos',
        title: '组 件',
        tip: _vm.tip,
        path: '/mobile/demos'
      }, {
        icon: 'shop',
        currentIcon: 'shopfill',
        alias: '/about',
        title: '关 于'
      }]
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "layout-top"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-body"
  }, [_vm._v("\n        Bone 4\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e351262!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home/app-mobile.vue
// module id = 235
// module chunks = 36